import { render } from "./BookMarkButton.vue?vue&type=template&id=038db9fa&scoped=true&ts=true"
import script from "./BookMarkButton.vue?vue&type=script&lang=ts"
export * from "./BookMarkButton.vue?vue&type=script&lang=ts"

import "./BookMarkButton.vue?vue&type=style&index=0&id=038db9fa&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038db9fa"]])

export default __exports__